import * as React from 'react';
import { PropsWithChildren } from 'react';

import { GetRequestHeadersQuery } from '@notino/shared/definitions/types';

export type FeatureFlags = Omit<
  GetRequestHeadersQuery['RequestHeaders']['featureFlags'],
  '__typename'
>;
const LDContext = React.createContext<FeatureFlags>(null);

export const FeatureFlagsProvider = ({
  children,
  featureFlags,
}: PropsWithChildren<{ featureFlags: FeatureFlags }>) => (
  <LDContext.Provider value={featureFlags}>{children}</LDContext.Provider>
);

export const useFeatureFlags = (): FeatureFlags => {
  const ctx = React.useContext(LDContext);
  if (!ctx) {
    throw new Error(
      'useFeatureFlags must be used inside FeatureFlagsProvider.'
    );
  }
  return ctx;
};
